<template>
    <div style="background-color: white;">
        <div class="card"
            style="padding: 24px; border-top-left-radius: 0 !important; border-top-right-radius: 0; border-radius: 10px">
            <div class="col-md-12 font-weight-bold mb-4" style="font-size: 1.6em; padding-left: 6px;">
                Declined Letter
            </div>

            <div class="row">
                <div class="col-md-6">
                    <TextInput label="Our Ref" :modelValue="data.claim_intimation_number" :readonly="true" />
                    <TextInput label="Takaful Certificate" :modelValue="data.certificate_number" :readonly="true" />
                    <TextInput label="Person" :modelValue="personCovered" :readonly="true" />
                </div>
                <div class="col-md-6">
                    <TextInput label="Date" type="date" :modelValue="formattedRejectedDate" :readonly="true" />
                    <TextInput label="Incident Date" type="date" :modelValue="formattedDate" :readonly="true" />
                </div>
            </div>
            <div class="form-group">
                <label>Content</label>
                <div id="app">
                    <ckeditor :editor="editor" v-model="content" :config="editorConfig"></ckeditor>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-start" style="margin-top: 24px ;">
            <button @click="handleSave(0)" v-if="(!letterData || letterData.submitted !== 1)"
                class="btn btn-lg btn-outline-primary col-2" style="margin-right: 10px;">
                Save as Draft
            </button>
            <button @click="handleSave(1)" v-if="(!letterData || letterData.submitted !== 1)"
                class="btn btn-lg btn-primary col-2" style="margin-right: 10px;">
                Submit
            </button>
            <button class="btn btn-lg btn-dark col-2" :class="{ 'disabled': !isSubmitted }" :disabled="!isSubmitted"
                @click="handlePreview">
                Preview
            </button>
        </div>
    </div>
</template>

<script>
import TextInput from '../../../components/TextInput.vue';
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import moment from "moment";
import { downloadLetter, getLetter, getLetterTemplate, storeLetter, updateLetter } from '../../../services/ClaimService';
import { global } from '../../../global';
import { getRequest } from '../../../services/RequestService';

export default {
    name: "DeclinedPage",
    components: {
        TextInput,
        ckeditor: CKEditor.component
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },

    computed: {
        formattedDate() {
            return moment(this.data.incident_date).format("YYYY-MM-DD");
        },
        formattedRejectedDate() {
            return moment(this.data.rejected_at).format("YYYY-MM-DD");
        },
        personCovered() {
            const found = this.data.claims_meta.find(item => item.meta_key === "person_covered");
            return found ? found.meta_value : '';
        }
    },

    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {},
            content: null,
            isSubmitted: false, // used to track if the letter has been submitted (draft or not)
            letterData: null,
        };
    },

    methods: {
        async fetchLetterTemplate() {
            try {
                const response = await getLetterTemplate(this.data.id);

                if (response.data.success) {
                    this.content = response.data.data
                }
            } catch (error) {
                console.error(error);
            }
        },

        async fetchLetter() {
            try {
                const response = await getLetter(this.data.id);

                if (response.data.success) {
                    if (response.data.data === null) {
                        this.fetchLetterTemplate();
                        this.isSubmitted = false;
                    } else {
                        this.content = response.data.data.content;
                        this.isSubmitted = true;
                        this.letterData = response.data.data;
                    }
                } else {
                    this.fetchLetterTemplate();
                    this.isSubmitted = false;
                }
            } catch (error) {
                console.error(error);
            }
        },

        validateContent() {
            if (!this.content || this.content.trim() === '') {
                swal({
                    icon: "error",
                    text: "Content cannot be empty"
                });
                return false;
            }
            return true;
        },

        handleSave(type) {
            // type 0 = draft, type 1 = submit
            if (!this.validateContent()) {
                return;
            }
            if (this.isSubmitted) {
                this.updateLetter(type)
            } else {
                this.storeLetter(type);
            }
        },
        async handlePreview() {
            try {
                const response = await getRequest(
                    `/claim/letter/download/${this.letterData.id}`,
                    { responseType: 'blob' }
                );

                const blob = new Blob([response.data], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(blob);

                window.open(fileURL, "_blank"); // Opens PDF in new tab
            } catch (error) {
                console.error("Preview failed", error);
            }
        },


        async storeLetter(type) {
            // type 0 = draft, type 1 = submit
            const request = {
                'claim_id': this.data.id,
                'reference_no': this.data.claim_intimation_number,
                'content': this.content,
                'letter_date': this.formattedDate,
                'submitted': type
            }
            try {
                const response = await storeLetter(request);
                if (response.data.success) {
                    swal({
                        icon: "success",
                        text: response.data.message
                    })
                    this.fetchLetter();
                } else {
                    swal({
                        icon: "error",
                        text: "Error saving letter"
                    })
                }
            } catch (error) {
                console.error(error)

                if (error) {
                    swal({
                        icon: "error",
                        text: "Error saving letter"
                    })
                }
            }
        },

        async updateLetter(type) {
            const request = {
                'claim_id': this.data.id,
                'reference_no': this.data.claim_intimation_number,
                'content': this.content,
                'letter_date': this.formattedDate,
                'submitted': type
            }

            try {
                const response = await updateLetter(request, this.letterData.id);
                if (response.data.success) {
                    swal({
                        icon: "success",
                        text: response.data.message
                    })
                    this.fetchLetter();
                } else {
                    swal({
                        icon: "error",
                        text: "Error updating letter"
                    })
                }
            } catch (error) {
                console.error(error)
                if (error) {
                    swal({
                        icon: "error",
                        text: error
                    })
                }
            }
        }
    },

    mounted() {
        if (this.data.id) {
            this.fetchLetter();
        }
    },
};
</script>
